module.exports = __webpack_public_path__ + "img/83.cc3e8217.jpg";